import React from "react";
import styles from "./SwitchButton.module.css";

export default function SwitchButton({ disabled, onClickMethod, checked }) {
	return (
		<label className={styles.switch}>
			<input
				type="checkbox"
				disabled={disabled || false}
				onClick={onClickMethod}
				checked={checked}
				onChange={() => {}}
			/>
			<span className={`${styles.slider} ${styles.round}`}></span>
		</label>
	);
}
